import { createElement } from 'rax';
import classNames from 'classnames';
import Text from 'rax-text';
import View from '../view';
const DateIndicator = (props) => {
    const { prefix = 'mt-', highlight, separator = ' ', values = [] } = props;
    const clsPrefix = `${prefix}datepicker`;
    return (<View className={`${clsPrefix}-time-indicator`}>
      <Text className={classNames(`${clsPrefix}-time-indicator-text`, {
            [`${clsPrefix}-time-indicator--highlight`]: highlight === 0,
        })} x-if={highlight === 0}>
        {values[0]}
      </Text>
      <Text className={`${clsPrefix}-time-indicator-text`}>{separator}</Text>
      <Text className={classNames(`${clsPrefix}-time-indicator-text`, {
            [`${clsPrefix}-time-indicator--highlight`]: highlight === 1,
        })} x-if={highlight === 1}>
        {values[1]}
      </Text>
    </View>);
};
export default DateIndicator;
